import { useQuery } from '@tanstack/react-query';

import { createClient } from 'contentful';

import { getConfig } from '../../utils/getConfig.js';
import { GlobalAlertBannerSkeleton } from './types.js';

const client = createClient({
  space: getConfig('CONTENTFUL_SPACE_ID'),
  accessToken: getConfig('CONTENTFUL_CONTENT_DELIVERY_ACCESS_TOKEN'),
});

async function getEntries() {
  const entryItems = await client.getEntries<GlobalAlertBannerSkeleton>({
    content_type: 'globalAlertBanner',
    'fields.isLive': true,
  });
  return entryItems.items;
}

export function useGlobalAlerts() {
  const { data, isLoading, isError } = useQuery(['globalAlertBanner'], getEntries, {
    staleTime: 60_000 * 3,
  });
  return { alerts: data, isLoading, isError };
}
